<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-12-04 10:40:10
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-03-28 13:07:41
 * @FilePath: \miniproweb\src\views\StationInfo\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="InfoBox">
    <div class="infoTitle">实况监测与查询统计</div>
    <div class="mapBox" id="map"></div>
    <van-popup v-model="show">
      <div class="popBox">
        <div style="text-align:center">站点信息</div>
        <div class="textBox3" style="margin-top:10px">
          <div>站名</div>
          <div>{{chooseItem.stationName}}</div>
        </div>
        <div class="textBox3" style="margin-top:10px">
          <div>站号</div>
          <div>{{chooseItem.stationNum}}</div>
        </div>
        <div class="textBox3" style="margin-top:10px">
          <div>温度</div>
          <div>{{chooseItem.temAvg}}℃</div>
        </div>
        <div class="textBox3" style="margin-top:10px">
          <div>最高气温</div>
          <div>{{chooseItem.temMax}}℃</div>
        </div>
        <div class="textBox3" style="margin-top:10px">
          <div>最低气温</div>
          <div>{{chooseItem.temMin}}℃</div>
        </div>
        <div class="textBox3" style="margin-top:10px">
          <div>平均气压</div>
          <div>{{chooseItem.prsAvg}}</div>
        </div>
        <div class="textBox3" style="margin-top:10px">
          <div>最大气压</div>
          <div>{{chooseItem.prsMax}}</div>
        </div>
        <div class="textBox3" style="margin-top:10px">
          <div>最小气压</div>
          <div>{{chooseItem.prsMin}}</div>
        </div>
        <div class="textBox3" style="margin-top:10px">
          <div>平均相对湿度</div>
          <div>{{chooseItem.rhuAvg}}%</div>
        </div>
      </div>
    </van-popup>
    <div class="weatherTypeBox">
      查询类型：
      <el-radio-group v-model="showType" size="mini" @change="showTypeChange">
        <el-radio-button label="实况"></el-radio-button>
        <el-radio-button label="统计"></el-radio-button>
      </el-radio-group>要素选择：
      <el-select
        v-model="value"
        placeholder="请选择"
        size="mini"
        @change="typeChange"
        style="width:100px"
      >
        <el-option v-for="item in options" :key="item.name" :label="item.name" :value="item.type"></el-option>
      </el-select>
    </div>
    <div class="tavbvbleBox">
      <el-table :data="tableData" border style="width: 100%" height="350" v-show="showType=='实况'">
        <el-table-column prop="stationName" label="站名"></el-table-column>
        <el-table-column prop="stationNum" label="站号"></el-table-column>
        <el-table-column prop="dateTime" label="时间"></el-table-column>
        <el-table-column :prop="value" :label="chooseLable">
          <template slot-scope="scope">
            <div>{{dataHanderller(scope.row[value])}}</div>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="tableData2" height="350" border v-show="showType=='统计'">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="stationName" label="站点"></el-table-column>
        <el-table-column :prop="valueType" label="观测值">
          <template slot-scope="scope">
            <div>{{dataHanderller(scope.row[value])}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="趋势">
          <template slot-scope="scope">下降</template>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="gotoPage(scope.row,valueType)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { MapCreate, legendColor } from "../../map/mapImport.js";
import moment from "moment";
export default {
  data() {
    return {
      chooseType: "温度",
      valueType: "temAvg",
      showType: "实况",
      tableData: [],
      tableData2: [],
      map: null,
      markerList: [],
      markerLayer: null,
      show: false,
      chooseItem: {},
      chooseLable: "温度",
      value: "temAvg",
      options: [
        {
          name: "温度",
          type: "temAvg"
        },
        // {
        //   name: "最高气温",
        //   type: "temMax"
        // },
        // {
        //   name: "最低气温",
        //   type: "temMin"
        // },
        // {
        //   name: "平均气压",
        //   type: "prsAvg"
        // },
        // {
        //   name: "最大气压",
        //   type: "prsMax"
        // },
        // {
        //   name: "最小气压",
        //   type: "prsMin"
        // },
        // {
        //   name: "平均相对湿度",
        //   type: "rhuAvg"
        // },
        // {
        //   name: "能见度",
        //   type: "rhuAvg"
        // },

        {
          name: "降水",
          type: "pre1h"
        },
        {
          name: "湿度",
          type: "rhuAvg"
        },
        {
          name: "风速",
          type: "winSAvg2mi"
        }
      ]
    };
  },
  mounted() {
    this.map = new MapCreate();
    //   this.map.init();
    this.map.init("map");
  },
  created() {
    this.getTableData();
    this.getData();
  },
  methods: {
    showTypeChange(e) {
      console.log(e);
      if (e == "实况") {
        // this.options = [
        //   {
        //     name: "温度",
        //     type: "temAvg"
        //   },
        //   {
        //     name: "最高气温",
        //     type: "temMax"
        //   },
        //   {
        //     name: "最低气温",
        //     type: "temMin"
        //   },
        //   {
        //     name: "平均气压",
        //     type: "prsAvg"
        //   },
        //   {
        //     name: "最大气压",
        //     type: "prsMax"
        //   },
        //   {
        //     name: "最小气压",
        //     type: "prsMin"
        //   },
        //   {
        //     name: "平均相对湿度",
        //     type: "rhuAvg"
        //   },
        //   {
        //     name: "能见度",
        //     type: "rhuAvg"
        //   }
        // ];
        this.options = [
          {
            name: "温度",
            type: "temAvg"
          },
          // {
          //   name: "最高气温",
          //   type: "temMax"
          // },
          // {
          //   name: "最低气温",
          //   type: "temMin"
          // },
          // {
          //   name: "平均气压",
          //   type: "prsAvg"
          // },
          // {
          //   name: "最大气压",
          //   type: "prsMax"
          // },
          // {
          //   name: "最小气压",
          //   type: "prsMin"
          // },
          // {
          //   name: "平均相对湿度",
          //   type: "rhuAvg"
          // },
          // {
          //   name: "能见度",
          //   type: "rhuAvg"
          // },

          {
            name: "降水",
            type: "pre1h"
          },
          {
            name: "湿度",
            type: "rhuAvg"
          },
          {
            name: "风速",
            type: "winSAvg2mi"
          }
        ];
      } else {
        this.options = [
          {
            name: "温度",
            type: "temAvg"
          },
          {
            name: "降水",
            type: "pre1h"
          },
          {
            name: "湿度",
            type: "rhuAvg"
          },
          {
            name: "风速",
            type: "winSAvg2mi"
          }
          // {
          //   name: "能见度",
          //   type: "rhuAvg"
          // }
        ];
      }
    },
    dataHanderller(data) {
      if (data == 999999) {
        return "/";
      } else {
        return data;
      }
    },
    gotoPage(e, data) {
      console.log(e, data);
      this.$router.push({
        name: "Echart",
        params: {
          sta: e,
          type: this.chooseLable
        }
      });
    },

    getData() {
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/HourDataService/hourDataImageTest?datetime=${moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD HH:00:00")}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        this.tableData = res.data.data;
      });
    },
    typeChange(e) {
      console.log();
      this.chooseLable = this.options.find(item => {
        return item.type == e;
      }).name;
    },
    getTableData() {
      console.log(moment().minute());
      let time = moment()
        .subtract(1, "h")
        .format("YYYY-MM-DD HH:00:00");
      if (moment().minute() > 30) {
        time = moment().format("YYYY-MM-DD HH:00:00");
      } else {
        time = moment()
          .subtract(1, "h")
          .format("YYYY-MM-DD HH:00:00");
      }
      this.$axios({
        method: "get",
        url: `http://120.79.183.250:3093/InterfaceServices/HourDataService/queryHourListByDate?datetime=${time}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }).then(res => {
        console.log(res.data.data);
        this.tableData2 = res.data.data;
        let list = [];
        let t = this;
        this.tableData2.map(item => {
          list.push(
            L.marker([item.lat, item.lon]).on("click", () => {
              console.log(item);
              t.chooseItem = item;
              t.show = true;
              // t.openVideoPop();
            })
          );
        });

        this.markerLayer = L.layerGroup(list).addTo(this.map.map);
      });
    }
  }
};
</script>

<style>
.InfoBox {
  height: 100vh;
  width: 100vw;
  background-color: #111b2e;
  overflow-y: auto;
}
.infoTitle {
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: white;
}
.tavbvbleBox {
  /* padding: 0 5px; */
  height: 50vh;
  overflow: auto;
}
.mapBox {
  height: 300px;
  width: 100%;
}
.popBox {
  /* height: 200px; */
  width: 200px;
  padding: 10px;
  /* border-radius: 10px; */
}
.textBox3 {
  /* height: 30px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
}
.weatherTypeBox {
  height: 50px;
  width: 100%;
  color: black;
  /* line-height: 30px; */
  display: flex;
  align-items: center;
  /* justify-content: center; */
  justify-content: space-between;
  font-size: 12px;
  background-color: white;
  /* padding: 0 20px; */
}
</style>